import { Stack, Typography } from "@mui/material";
import Logo from "../../../assets/an_purple_butterfly_logo.png";
import React from "react";

export default function TitleSection({ title, subtitle, imageSrc }) {
  return (
    <Stack gap={4}>
      <img
        src={Logo}
        alt="AnswersNow"
        title="AnswersNow"
        style={{ height: "29px", width: "27.52px" }}
      />
      {imageSrc && (
        <img src={imageSrc} alt={title} title={title} style={{ height: "225px", width: "225px" }} />
      )}
      <Typography fontFamily="TestTiemposText" fontSize="35px" fontWeight="500" variant="h1">
        {title}
      </Typography>
      {subtitle && <Typography variant="h2">{subtitle}</Typography>}
    </Stack>
  );
}
